








import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
	name: 'RsLabel',
	components: {},
})
export default class Label extends Vue {
	@Prop()
	private value!: any
}
